import { createContext, useContext, useState, ReactNode, SetStateAction, Dispatch, useCallback } from 'react';
import { defaultModaisState, ModaisKeys, ModaisStates, Programas } from './defaultModaisStateValues';


interface ModalStateContextProps {
    modais: ModaisStates;
    setModais: Dispatch<SetStateAction<ModaisStates>>;
    handleToggleModal: <T extends Programas>(programa: T, prop: ModaisKeys<T>, value: boolean) => void;
}

const ModalStateContext = createContext<ModalStateContextProps | undefined>(undefined);

export const useModalStateContext = (): ModalStateContextProps => {
    const context = useContext(ModalStateContext);

    return context as ModalStateContextProps;
};

interface ModalProviderProps {
    children: ReactNode;
}

export const ModalStateContextProvider: React.FC<ModalProviderProps> = ({ children }) => {
    const [modais, setModais] = useState<ModaisStates>(defaultModaisState);
    const handleToggleModal = useCallback(<T extends Programas>(programa: T, prop: ModaisKeys<T>, value: boolean) => {
        setModais(prevState => ({
            ...prevState,
            [programa]: {
                ...prevState[programa],
                [prop]: value
            }
        }))
    }, [])

    return (
        <ModalStateContext.Provider value={{ modais, setModais, handleToggleModal }}>
            {children}
        </ModalStateContext.Provider>
    );
};